export const MOBILE_BREAKPOINT = '960px';
export const MOBILE_MEDIA_QUERY = `only screen and (max-width: ${MOBILE_BREAKPOINT})`;
export const SURVEY_MOBILE_FOOTER_BREAKPOINT = '744px'; // this has to match styles from common-survey
